//TODO SACAR ADMINISTRATOR
export const buildLoggedUser = user => ({
    ...user,
    lastName: user.last_name,
    profile: [user.profile.code]
});
